export default {
  me: {},
  posts: {}
}
